import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TCommonRowData, TMediaPlanList, TSelectedDateRange } from "@ts/common-types";
import dayjs from "dayjs";

const overviewKeywordsSelectionDataSlice = createSlice({
    name: "overviewKeywordsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateOverviewKeywordsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const campaignSelectionDataSlice = createSlice({
    name: "campaignsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateCampaignsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        }
    }
});

const adgroupSelectionDataSlice = createSlice({
    name: "adgroupSelectionData",
    initialState: { value: [] },
    reducers: {
        updateAdgroupSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        }
    }
})

const keywordsSelectionDataSlice = createSlice({
    name: "keywordsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateKeywordsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const productsSelectionDataSlice = createSlice({
    name: "productsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateProductsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const productAdgroupsSelectionDataSlice = createSlice({
    name: "productAdgroupsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateProductAdgroupsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const negativeKeywordsSelectionDataSlice = createSlice({
    name: "negativeKeywordsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateNegativeKeywordsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const historyLogsSelectionDataSlice = createSlice({
    name: "historyLogsSelectionData",
    initialState: { value: [] },
    reducers: {
        updateHistoryLogsSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const productMappingSelectionDataSlice = createSlice({
    name: "productMappingSelectionData",
    initialState: { value: [] },
    reducers: {
        updateProductMappingSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordMappingSelectionDataSlice = createSlice({
    name: "keywordMappingSelectionData",
    initialState: { value: [] },
    reducers: {
        updateKeywordMappingSelectionData: (
            state,
            action: PayloadAction<TCommonRowData>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordMappingAllPagesSelectedSlice = createSlice({
    name: "keywordMappingAllPagesSelected",
    initialState: { value: false },
    reducers: {
        updateKeywordMappingAllPagesSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const productMappingAllPagesSelectedSlice = createSlice({
    name: "productMappingAllPagesSelected",
    initialState: { value: false },
    reducers: {
        updateProductMappingAllPagesSelected: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const productMappingHeaderSelectionSlice = createSlice({
    name: "productMappingHeaderSelection",
    initialState: { value: false },
    reducers: {
        updateProductMappingHeaderSelection: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const keywordMappingHeaderSelectionSlice = createSlice({
    name: "keywordMappingHeaderSelection", 
    initialState: { value: false },
    reducers: {
        updateKeywordMappingHeaderSelection: (
            state,
            action: PayloadAction<boolean>
        ) => {
            state.value = action.payload;
        },
    },
});

const selectedMediaPlanDataSlice = createSlice({
    name: "selectedMediaPlanData",
    initialState: { value: {} },
    reducers: {
        setSelectedMediaPlanData: (
            state,
            action: PayloadAction<TMediaPlanList>
        ) => {
            state.value = action.payload;
        },
    },
})

const selectedDateRangeSlice = createSlice({
    name: "selectedDateRange",
    initialState: { value: { 
        dateRange: { 
            start: dayjs().subtract(30, 'day').format('YYYY-MM-DD'), 
            end: dayjs().subtract(1, 'day').format('YYYY-MM-DD') 
        }, 
        compareDateRange: { 
            start: dayjs().subtract(60, 'day').format('YYYY-MM-DD'), 
            end: dayjs().subtract(30, 'day').format('YYYY-MM-DD') 
        }, 
        selectedRange: "l30d"
    } },
    reducers: {
        updateSelectedDateRange: (
            state,
            action: PayloadAction<TSelectedDateRange>
        ) => {
            state.value.dateRange = action.payload.dateRange;
            state.value.compareDateRange = action.payload.compareDateRange;
            state.value.selectedRange = action.payload.selectedRange;
        },
    },
})





export const { updateOverviewKeywordsSelectionData } =
    overviewKeywordsSelectionDataSlice.actions;
export const { updateCampaignsSelectionData } =
    campaignSelectionDataSlice.actions;
export const { updateAdgroupSelectionData } =
    adgroupSelectionDataSlice.actions;
export const { updateKeywordsSelectionData } =
    keywordsSelectionDataSlice.actions;
export const { updateProductsSelectionData } =
    productsSelectionDataSlice.actions;
export const { updateProductAdgroupsSelectionData } =
    productAdgroupsSelectionDataSlice.actions;
export const { updateNegativeKeywordsSelectionData } =
    negativeKeywordsSelectionDataSlice.actions;
export const { updateHistoryLogsSelectionData } =
    historyLogsSelectionDataSlice.actions;
export const { updateProductMappingSelectionData } =
    productMappingSelectionDataSlice.actions;
export const { updateKeywordMappingSelectionData } =
    keywordMappingSelectionDataSlice.actions;
export const { updateKeywordMappingAllPagesSelected } =
    keywordMappingAllPagesSelectedSlice.actions;
export const { updateProductMappingAllPagesSelected } =
    productMappingAllPagesSelectedSlice.actions;
export const { updateProductMappingHeaderSelection } = productMappingHeaderSelectionSlice.actions;
export const { updateKeywordMappingHeaderSelection } = keywordMappingHeaderSelectionSlice.actions;
export const { setSelectedMediaPlanData } =
    selectedMediaPlanDataSlice.actions;
export const { updateSelectedDateRange } = selectedDateRangeSlice.actions;


export const overviewKeywordsSelectionDataReducer =
    overviewKeywordsSelectionDataSlice.reducer;
export const campaignsSelectionDataReducer =
    campaignSelectionDataSlice.reducer;
export const adgroupSelectionDataReducer =
    adgroupSelectionDataSlice.reducer;
export const keywordsSelectionDataReducer =
    keywordsSelectionDataSlice.reducer;
export const productsSelectionDataReducer =
    productsSelectionDataSlice.reducer;
export const productAdgroupsSelectionDataReducer =
    productAdgroupsSelectionDataSlice.reducer;
export const negativeKeywordsSelectionDataReducer =
    negativeKeywordsSelectionDataSlice.reducer;
export const historyLogsSelectionDataReducer =
    historyLogsSelectionDataSlice.reducer;
export const productMappingSelectionDataReducer =
    productMappingSelectionDataSlice.reducer;
export const keywordMappingSelectionDataReducer =
    keywordMappingSelectionDataSlice.reducer;
export const keywordMappingAllPagesSelectedReducer =
    keywordMappingAllPagesSelectedSlice.reducer;
export const productMappingAllPagesSelectedReducer =
    productMappingAllPagesSelectedSlice.reducer;
export const productMappingHeaderSelectionReducer = 
    productMappingHeaderSelectionSlice.reducer;
export const keywordMappingHeaderSelectionReducer = 
    keywordMappingHeaderSelectionSlice.reducer;
export const selectedMediaPlanDataReducer =
    selectedMediaPlanDataSlice.reducer;
export const selectedDateRangeReducer =
    selectedDateRangeSlice.reducer;    
